import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLexiconConceptApiLexiconConceptsUniqueDelete } from "@noa/api-core";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";
import { LexiconQueryKey } from "../../query-keys";

type DeleteLexiconConceptParams = {
  unique: string;
  subject_en: string | null;
  subject_fr: string | null;
};

const deleteLexicalConcept = async ({ unique }: DeleteLexiconConceptParams) => {
  await deleteLexiconConceptApiLexiconConceptsUniqueDelete({
    path: { unique },
    throwOnError: true,
  });
};

export const useDeleteLexiconConcept = () => {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, DeleteLexiconConceptParams>({
    mutationFn: deleteLexicalConcept,
    onError: reportError,
    onSuccess: (_data, { subject_en, subject_fr }) => {
      void queryClient.invalidateQueries({ queryKey: [...LexiconQueryKey.all, "subjects"] });
      if (subject_fr) {
        void queryClient.invalidateQueries({ queryKey: LexiconQueryKey.conceptsBySubject(subject_fr) });
      }
      if (subject_en) {
        void queryClient.invalidateQueries({ queryKey: LexiconQueryKey.conceptsBySubject(subject_en) });
      }
    },
  });
};
